export const pointsMinZoom = 12;

export const FRESHEST_CENSUS_ACS5 = 2024;

// The <title> for /pricing. Both the route's `title` and pricingPageTags
// write document.title for this page, so two different strings means one of
// them is dead config that silently loses to whichever runs last - the same
// single-source rule the sales-forecast routes follow via routeTitle().
// Lives here rather than in seo-tags.ts because the eagerly-loaded router
// needs it, and importing seo-tags.ts there would pull every page's meta
// copy into the initial bundle.
export const PRICING_PAGE_TITLE = 'Pricing: Subscriptions & PDF Reports | Map AI';
